<template>
  <v-container fluid>
    <data-table
      :headers="headers"
      :items="category"
      commit="SET_CATEGORY"
      :viewItem="viewItem"
      :editItem="editItem"
      :deleteItem="deleteItem"
    >
      <div slot="activator" class="row justify-content-between mb-4">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
          <v-card-title class="px-0 pt-0 ps-products-title">
            {{ $t("category") }}
          </v-card-title>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 offset-lg-5">
          <TextSearch
            v-model="search"
            @search="fetchItem()"
            @onClear="
              search = '';
              fetchItem();
            "
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 text-end">
          <v-btn
            depressed
            color="primary"
            class="white--text btn-primary-brand"
            @click="newItem"
          >
            <v-icon left small>fal fa-plus</v-icon>
            {{ $t("new_data") }}
          </v-btn>
        </div>
      </div>
    </data-table>

    <app-custom-dialog
      v-model="dialog"
      :footer="false"
      title="description"
      @submit="submitForm"
    >
      <div slot="activator">
        <v-row>
          <v-col cols="4">{{ $t("id") }}</v-col>
          <v-col cols="8">{{ form.id }}</v-col>
          <v-col cols="4">{{ $t("lao_name") }}</v-col>
          <v-col cols="8">{{ form.la_name }}</v-col>
          <v-col cols="4">{{ $t("eng_name") }}</v-col>
          <v-col cols="8">{{ form.en_name }}</v-col>
          <v-col cols="4">{{ $t("date") }}</v-col>
          <v-col cols="8">{{ form.created_at | moment }}</v-col>
        </v-row>
      </div>
    </app-custom-dialog>
    <app-custom-dialog
      v-model="dialogAdd"
      :footer="true"
      :title="titleStatus"
      :submit-text="update ? 'save' : 'add'"
      :submit-loading="submitting"
      @submit="submitForm"
    >
      <div slot="activator">
        <TTextField
          label="la_name"
          :errorMessages="nameError"
          v-model="form.la_name"
          @input="$v.form.la_name.$touch()"
          @blur="$v.form.la_name.$touch()"
        />
        <TTextField label="en_name" v-model="form.en_name" />
      </div>
    </app-custom-dialog>
    <!-- AppLoading -->
    <app-loading :overlay="overlay" />
  </v-container>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import { productCategory } from "@/utils/head";
import TTextField from "@/components/global/TextField";
import { CategoryValidate } from "@/validations/shop";
import { success, confirm, toast } from "@/controllers/alert";
import { myMixin } from "@/mixin/main";

const defaultCategoryForm = () => ({
  la_name: "",
  en_name: "",
  is_online: 1,
  is_cooking: 0,
});

export default {
  mixins: [CategoryValidate, myMixin],
  data: () => ({
    update: false,
    dialogAdd: false,
    dialog: false,
    overlay: false,
    submitting: false,
    search: "",
    form: defaultCategoryForm(),
  }),
  async created() {
    await this.fetchItem();
  },
  components: { DataTable, TTextField },
  computed: {
    ...mapGetters({
      category: "index/category",
    }),

    titleStatus() {
      return this.update ? "update" : "new_data";
    },
    headers() {
      return productCategory(this);
    },
  },

  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async fetchItem() {
      const body = {
        that: this,
        url: `categories_paginate?q=${this.search}&is_online=1`,
        commit: "SET_CATEGORY",
      };
      await this.fetch(body);
    },

    newItem() {
      if (this.$v && this.$v.form) {
        this.$v.form.$reset();
      }
      this.form = defaultCategoryForm();
      this.update = false;
      this.dialogAdd = true;
    },

    editItem(item) {
      if (this.$v && this.$v.form) {
        this.$v.form.$reset();
      }
      this.update = true;
      this.form = {
        ...defaultCategoryForm(),
        ...item,
      };
      this.dialogAdd = true;
    },
    async deleteItem({ id }) {
      const { isConfirmed } = await confirm({
        props: this,
        text: "want_to_delete",
      });
      if (isConfirmed) {
        try {
          const { data } = await this.$http.delete(`categories/${id}`);
          if (data && data.status) {
            await this.fetchItem();
            await success(this, data.message);
          } else {
            await toast(this, data?.message || "error_occurred", "error");
          }
        } catch (error) {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            this.$t("error_occurred") ||
            "Error";
          if (this.$toast) {
            this.$toast.error(message);
          } else {
            await toast(this, message, "error");
          }
        }
      }
    },
    viewItem(item) {
      this.form = {
        ...defaultCategoryForm(),
        ...item,
      };
      this.dialog = true;
    },
    async submitForm() {
      try {
        this.$v.form.$touch();
        if (this.$v.form.$invalid) {
          return;
        }

        this.submitting = true;
        const body = {
          la_name: this.form.la_name,
          en_name: this.form.en_name,
          is_online: 1,
          is_cooking: 0,
        };

        if (this.update) {
          const { data } = await this.$http.put(
            `categories/${this.form.id}`,
            body
          );
          if (data && data.status) {
            this.dialogAdd = false;
            await this.fetchItem();
            await success(this, data.message);
          } else {
            await toast(this, data?.message || "error_occurred", "error");
          }
        } else {
          const { data } = await this.$http.post("categories", body);
          if (data && data.status) {
            this.dialogAdd = false;
            await this.fetchItem();
            await success(this, data.message);
          } else {
            await toast(this, data?.message || "error_occurred", "error");
          }
        }
      } catch (error) {
        console.error("error submitting category", error);
        const message =
          error?.response?.data?.message ||
          error?.message ||
          this.$t("error_occurred") ||
          "Error";
        if (this.$toast) {
          this.$toast.error(message);
        } else {
          await toast(this, message, "error");
        }
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.ps-products-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}
</style>
